import { render, staticRenderFns } from "./ConsignmentNoteCreateForm.vue?vue&type=template&id=876f8748&scoped=true&"
import script from "./ConsignmentNoteCreateForm.vue?vue&type=script&lang=js&"
export * from "./ConsignmentNoteCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876f8748",
  null
  
)

export default component.exports